import React from "react";
import { v4 as uuidv4 } from "uuid";
import History from "../../utilities/History";

import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import testplanActions from "../../flux/actions/TestplanActions";
import testplanListStore from "../../flux/stores/testplan/ListStore";
import propertyActions from "../../flux/actions/PropertyActions";

import {
  ITestplanViewData,
  defaultTestplanData,
} from "../../models/testplan/TestplanViewData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../models/shared/SidebarDetail";
import { TestplanFormData } from "../../models/testplan/TestplanFormData";
import IActionHeaderFormData, {
  IActionHeaderEditData,
} from "../../models/shared/ActionHeaderData";

import * as CONSTANTS from "../../utilities/Constants";

import { Translation } from "react-i18next";

import "./testplan.sass";
import testplanDeleteStore from "../../flux/stores/testplan/DeleteStore";
import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";
import SidebarLayout from "../shared/SidebarLayout";
import SidebarTitle from "../shared/SidebarTitle";
import { ICalculatedPropertyData } from "../../models/shared/ICalculatedPropertyData";
import {
  InstrumentData,
  ITestPlanInstrument,
} from "../../models/testplan/TestplanInstrument";
import triggerNotifications from "../../utilities/TriggerNotifications";
import NoDataFound from "../shared/NoDataFound";
import SidebarCreate from "../shared/SidebarCreate";
import testplanFormStore from "../../flux/stores/testplan/FormStore";
import NoDataOnboarding from "../shared/NoDataOnboarding";
import loadingActions from "../../flux/actions/LoadingActions";
import { Input } from "@abb/abb-common-ux-react";

import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import "../sharedNew/sidebarCommon/sidebar.sass";
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import testPlanDisableStore from "../../flux/stores/testplan/DisableStore";
import testPlanEnableStore from "../../flux/stores/testplan/EnableStore";
import instrumentActions from "../../flux/actions/InstrumentActions";
import instrumentSelectedIdStore from "../../flux/stores/instrument/BySelectedIdStore";
import propertySelectedIdStore from "../../flux/stores/property/BySelectedIdStore";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import { PropertySpecification } from "../../models/shared/PropertySpecification";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import { Spinner } from "@abb/abb-common-ux-react";
interface IIndexState {
  activeId: string;
  activeItem: ITestplanViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  isClonedCreated: boolean;
  inputTestplanName: string;
  showPopup: boolean;
  inputCode: string;
  nameError: boolean;
  codeError: boolean;
  buttonDisabled: boolean;
  searchValue: string;
  collapseSidebar: boolean;
  isLoading: boolean;
}

export default class Index extends React.Component<
  { location: any },
  IIndexState
> {
  private _mount = false;
  private _reloadFirst = true;
  private _id = "";
  private _isSelectedLink = false;
  private _searchId = "";
  private _activeId = "";
  private _activeItem: ITestplanViewData;
  private _listData: ISidebarDetail[] = [];

  private _message: string[];
  private _isValid: boolean = false;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listRef: any;
  private _fetchedInstruments: any;
  private _fetchedProperties: any;

  constructor(props: { location: any }) {
    super(props);
    const searchName = this.props.location && this.props.location.state && this.props.location.state.searchName ? this.props.location.state.searchName : '';
    this._mount = false;
    this._listRef = React.createRef();
    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: searchName || "",
      activeItem: defaultTestplanData,
      listData: [],
      isFullSidebarVisible: true,
      isClonedCreated: false,
      inputTestplanName: "",
      showPopup: false,
      inputCode: "",
      nameError: false,
      codeError: false,
      buttonDisabled: true,
      isLoading: false
    };

    this._listData = [];
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    History.replace({ state: {} })
    this._mount = true;

    testplanFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._message = state.message;
      }
    });

    const addRequest = {
      moduleName: CONSTANTS.MODULE_TESTPLAN,
      createData: new TestplanFormData(
        false,
        uuidv4(),
        CONSTANTS.DefaultGuid,
        "",
        "",
        "",
        [],
        [],
        false
      ),
    } as IActionHeaderFormData;

    actionHeaderActions.common(addRequest).then();

    if (
      this.props.location.state &&
      this.props.location.state.isReloadFirst !== undefined
    ) {
      this._reloadFirst = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }

    if (
      this.props.location.state &&
      this.props.location.state.isSelectedLink !== undefined
    ) {
      this._isSelectedLink = this.props.location.state.isSelectedLink;
      this._searchId = this.props.location.state.id;
    }

    testplanDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        setTimeout(() => {
          History.push(CONSTANTS.TESTPLAN_INDEX_URL);
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    testplanListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        if (
          state.testplanDataList.currentPage ===
          state.testplanDataList.totalPages ||
          state.testplanDataList.totalRecords === 0
        ) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        const data = state.testplanDataList.result as ITestplanViewData[];
        data.forEach((element) => {
          this._listData.push(new SidebarDetail(element.id, element.name));
        });
      }
    });

    testplanByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._activeId = state.testplanData.id;
        this._activeItem = state.testplanData;
      }
    });

    instrumentSelectedIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._fetchedInstruments = state.instrumentDataList.result
        ? state.instrumentDataList.result : state.instrumentDataList
    })

    propertySelectedIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._fetchedProperties = state.data.result
        ? state.data.result
        : state.data;
    });

    testPlanDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    testPlanEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    this.getAll();
  }

  private getAll() {
    loadingActions.setLoading(true);
    this.setState({isLoading: true})
    if (this.state.isClonedCreated) {
      this._page = 1;
    }
    testplanActions
      .getAll(
        false,
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            listData: this._listData,
            isClonedCreated: false,
          },
          () => {
            if (this.state.listData.length > 0) {
              const firstItem = this.state.listData[0];

              if (this._reloadFirst) {
                if (this.state.listData.length > 0) {
                  this.triggerGetById(firstItem.id);
                } else {
                  const data: IActionHeaderEditData = {
                    moduleName: CONSTANTS.MODULE_TESTPLAN,
                    editData: {},
                    deleteTitle: "",
                    deleteId: "",
                    isEnableViewAll: false,
                    deleteRequestId: uuidv4(),
                    deleteMessage: "",
                  };

                  actionHeaderActions.edit(data).then();
                }
              } else {
                this.triggerGetById(this._id);
              }
              if (this.state.searchValue) {
                this.onsearch(this.state.searchValue);
              }
            }
            loadingActions.setLoading(false);
            this.setState({isLoading: false})
          }
        );
      })
      .catch(() => {
        loadingActions.setLoading(false)
        this.setState({isLoading: false})
      });
  }

  private triggerGetById(id: string) {
    testplanActions.getById(id).then(() => {
      this.setState(
        {
          activeId: this._activeId,
          activeItem: this._activeItem,
        },
        () => {
          const receivedData = this.state.activeItem;
          const allInstruments: any = [];
          const instrumentsToFetch: string[] = [];
          const properties: any = [];
          this._activeItem.instruments.forEach((d: any) => {
            instrumentsToFetch.push(d.id);
            allInstruments.push(d);
          });
          const propertiesToBeFetched: string[] = [];
          this._activeItem.keyedIns.forEach(
            (property: any) => {
              propertiesToBeFetched.push(property.id);
            }
          );
          instrumentActions.getSelected(instrumentsToFetch).then(() => {
            propertyActions.getSelected(propertiesToBeFetched).then(() => {
              this._fetchedInstruments?.forEach((i: IInstrumentViewData) => {
                i.properties.forEach((p: any) => {
                  const direction =
                    p.direction.name != CONSTANTS.ND
                      ? p.direction.name
                      : "";
                  const pName =
                    p.name + " (" + i.codeId + ")" + direction;
                  const max =
                    p.max === null || p.max === 0
                      ? ""
                      : String(p.max);
                  const min =
                    p.min === null || p.min === 0
                      ? ""
                      : String(p.min);
                  properties.push(
                    new PropertySpecification(
                      true,
                      false,
                      i.id,
                      p.id,
                      pName,
                      p.customId,
                      "",
                      "",
                      1,
                      0,
                      min,
                      max,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      [],
                      p.direction
                    )
                  )
                })
              })
              this._fetchedProperties.forEach(
                (p: IPropertyViewData) => {
                  properties.push(
                    new PropertySpecification(
                      false,
                      false,
                      "",
                      p.id,
                      p.name,
                      p.customId,
                      "",
                      "",
                      1,
                      0,
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      "",
                      []
                    )
                  );
                })
              receivedData.calculatedProperties.forEach(item => {
                properties.push(new PropertySpecification(false, true, "", item.property.id, item.property.name, item.property.customId, "",
                  "", 0, 1, "", "", "", "", "", "", "", "", item.sourceMappings ? item.sourceMappings : []));
              });
              const editData = new TestplanFormData(
                true,
                uuidv4(),
                receivedData.id,
                receivedData.name,
                receivedData.description,
                receivedData.codeId,
                receivedData.instruments,
                receivedData.keyedIns,
                receivedData.isPDC,
                receivedData.calculatedProperties,
                receivedData.sourceId,
              );
              editData.properties = properties;
              editData.isGradeCreatedWithTP = receivedData.isGradeCreatedWithTP;

              const data: IActionHeaderEditData = {
                moduleName: CONSTANTS.MODULE_TESTPLAN,
                editData: editData,
                deleteTitle: receivedData.name,
                deleteId: receivedData.id,
                deleteRequestId: uuidv4(),
                deleteMessage: receivedData.name,
              };

              actionHeaderActions.edit(data).then();
            })
          })
            .catch((error: any) => {
              triggerNotifications.errors(error.message, error.data).then();
            })
        }
      );
    })
      .catch((error: any) => {
        triggerNotifications.errors(error.message, error.data).then();
      })
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  };

  public setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      val.trim() &&
      !rgFile.test(val)
    ) {
      this.setState(
        { nameError: false, inputTestplanName: val },
        this.validate
      );
    } else {
      this.setState({ nameError: true, inputTestplanName: val }, this.validate);
    }
  };

  public setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
      this.setState({ codeError: false, inputCode: val }, this.validate);
    } else {
      this.setState({ codeError: true, inputCode: val }, this.validate);
    }
  };

  public onActivate = () => {
    this.setState({
      showPopup: true,
    });
  };

  public onDeactivate = () => {
    this.setState({
      showPopup: false,
    });
  };

  public onSave = (e: any, val: boolean) => {
    if (e !== null) {
      if (e.keyCode === 13) {
        this.setState({
          showPopup: false,
        });
        const testplanData = this.state.activeItem;
        let calcProps:any[] = testplanData.calculatedProperties;
        testplanData.calculatedProperties.map((data) => {
          const property = testplanData.calculatedProperties.find(x => x.property.id === data.property.id);
          const propertyIndex = testplanData.calculatedProperties.findIndex(x => x.property.id === data.property.id);
          if (property !== undefined) {
            if (data.formulaMappings !== undefined) {
              data.formulaMappings[0].variableMapping.map((variables: any) => {
                const sourceId = variables.variableMapping.source === null ? "" : variables.variableMapping.source.id;
                const position = variables.variableMapping.position === null ? "" : variables.variableMapping.position;
                const valueId = variables.variableMapping.value === null ? "" : variables.variableMapping.value.id;
                const sourceMappingData = {
                  sourceId,
                  position,
                  valueId,
                  propertyAttributeId: variables.attribute.id,
                  propertyId: variables.property.id,
                  variable: variables.variable,
                }
                calcProps[propertyIndex]?.sourceMappings?.push(sourceMappingData);
              });
            }
          }
        })
        if (this._isValid) {
          const tempName = this.state.inputTestplanName
            .replace(/ +(?= )/g, "")
            .trim();
          this.setState(
            {
              inputTestplanName: tempName,
            },
            () => {
              const testplanBody = new TestplanFormData(
                true,
                uuidv4(),
                testplanData.id,
                this.state.inputTestplanName,
                testplanData.description,
                this.state.inputCode,
                testplanData.instruments,
                testplanData.keyedIns,
                testplanData.isPDC,
                calcProps,
                testplanData.sourceId
              );
              testplanBody.isGradeCreatedWithTP = testplanData.isGradeCreatedWithTP
              const properties: any = []
              calcProps.forEach(item => {
                properties.push(new PropertySpecification(false, true, "", item.property.id, item.property.name, item.property.customId, "",
                  "", 0, 1, "", "", "", "", "", "", "", "", item.sourceMappings || []));
              });
              testplanBody.properties = properties;
              testplanBody.showGrade = false;
              testplanActions
                .post(
                  testplanBody,
                  testplanData.instruments,
                  testplanData.keyedIns
                )
                .then(() => {
                  triggerNotifications.success(this._message).then();
                  this.setState({
                    inputTestplanName: "",
                    inputCode: "",
                    buttonDisabled: true,
                    isClonedCreated: true,
                  });
                  this._listData = [];
                  this.getAll();
                  this._listRef.current.scrollTop = 0;
                })
                .catch((error) => {
                  triggerNotifications.errors(error.message, error.data).then();
                  this.setState({
                    inputTestplanName: "",
                    inputCode: "",
                    buttonDisabled: true,
                    isClonedCreated: false,
                  });
                });
            }
          );
        }
      }
    } else {
      this.setState({
        showPopup: false,
      });
      const testplanData = this.state.activeItem;
      let calcProps:any[] = testplanData.calculatedProperties;
      testplanData.calculatedProperties.map((data) => {
        const property = testplanData.calculatedProperties.find(x => x.property.id === data.property.id);
        const propertyIndex = testplanData.calculatedProperties.findIndex(x => x.property.id === data.property.id);
        if (property !== undefined) {
          if (data.formulaMappings !== undefined) {
            data.formulaMappings[0].variableMapping.map((variables: any) => {
              const sourceId = variables.variableMapping.source === null ? "" : variables.variableMapping.source.id;
              const position = variables.variableMapping.position === null ? "" : variables.variableMapping.position;
              const valueId = variables.variableMapping.value === null ? "" : variables.variableMapping.value.id;
              const sourceMappingData = {
                sourceId,
                position,
                valueId,
                propertyAttributeId: variables.attribute.id,
                propertyId: variables.property.id,
                variable: variables.variable,
              }
              calcProps[propertyIndex]?.sourceMappings?.push(sourceMappingData);
            });
          }
        }
      })
      if (this._isValid) {
        const tempName = this.state.inputTestplanName
          .replace(/ +(?= )/g, "")
          .trim();
        this.setState(
          {
            inputTestplanName: tempName,
          },
          () => {
            const testplanBody = new TestplanFormData(
              true,
              uuidv4(),
              testplanData.id,
              this.state.inputTestplanName,
              testplanData.description,
              this.state.inputCode,
              testplanData.instruments,
              testplanData.keyedIns,
              testplanData.isPDC,
              calcProps,
              testplanData.sourceId
            );
            testplanBody.isGradeCreatedWithTP = testplanData.isGradeCreatedWithTP
            const properties: any = []
            calcProps.forEach(item => {
              properties.push(new PropertySpecification(false, true, "", item.property.id, item.property.name, item.property.customId, "",
                "", 0, 1, "", "", "", "", "", "", "", "", item.sourceMappings || []));
            });
            testplanBody.properties = properties;
            testplanBody.showGrade = false;
            testplanActions
              .post(
                testplanBody,
                testplanData.instruments,
                testplanData.keyedIns
              )
              .then(() => {
                triggerNotifications.success(this._message).then();
                this.setState({
                  inputTestplanName: "",
                  inputCode: "",
                  buttonDisabled: true,
                  isClonedCreated: true,
                });
                this._listData = [];
                this.getAll();
                this._listRef.current.scrollTop = 0;
              })
              .catch((error) => {
                triggerNotifications.errors(error.message, error.data).then();
                this.setState({
                  inputTestplanName: "",
                  inputCode: "",
                  buttonDisabled: true,
                  isClonedCreated: false,
                });
              });
          }
        );
      }
    }
  };

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.inputTestplanName.trim() &&
      this.state.inputTestplanName !== ""
    ) {
      this._isValid = true;
      this.setState({
        buttonDisabled: false,
      });
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true,
      });
    }
  }

  public onCreateClick = () => {
    const createData = new TestplanFormData(
      false,
      uuidv4(),
      CONSTANTS.DefaultGuid,
      "",
      "",
      "",
      [],
      [],
      false
    );

    History.push(CONSTANTS.TESTPLAN_CREATE_URL, createData);
  };

  public onsearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      testplanActions
        .getAll(
          false,
          1,
          CONSTANTS.PAGE_SIZE,
          CONSTANTS.SORT_CREATEDON,
          CONSTANTS.SORT_ORDER,
          value
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState(
            { listData: this._listData, searchValue: value },
            () => {
              const firstItem = this.state.listData[0];
              if (this.state.listData.length > 0) {
                if (this._isSelectedLink) {
                  this.triggerGetById(this._searchId);
                } else {
                  this.triggerGetById(firstItem.id);
                }
              }
            }
          );
        });
    } else {
      this.setState({ searchValue: value });
    }
  };

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    testplanActions
      .getAll(
        false,
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        this.state.searchValue
      )
      .then(() => {
        loadingActions.setLoading(false);
        const data = [...this.state.listData, ...this._listData];
        this.setState({ listData: data });
      })
      .catch(() => loadingActions.setLoading(false));
  };

  public viewAll() {
    History.push(CONSTANTS.TESTPLAN_VIEW_ALL);
  }

  onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar,
    });
  };
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
            (<>{this.state.listData.length === 0 &&
              this.state.searchValue.length === 0 ? (
              <NoDataOnboarding
                moduleName={CONSTANTS.MODULE_TESTPLAN}
                onCreateClick={this.onCreateClick}
                authKey={CONSTANTS.AUTHKEY_TEST_PLAN}
              />
            ) : (

              <React.Fragment>
                {!this.state.collapseSidebar ? (
                  <div>
                    <Sidebar
                      authKey={CONSTANTS.AUTHKEY_TEST_PLAN}
                      onCollapseSidebar={this.onCollapseSidebar}
                      searchValue={this.state.searchValue}
                      onSearch={this.onsearch}
                      onCreateClick={this.onCreateClick}
                      viewAll={this.viewAll}
                      showCloneIcon={true}
                      setName={(val: string) => this.setName(val)}
                      inputName={this.state.inputTestplanName}
                      isShowPopup={this.state.showPopup}
                      module={CONSTANTS.MODULE_TESTPLAN}
                      isShowCodeInput={false}
                      setCode={(val: string) => this.setCode(val)}
                      inputCode={this.state.inputCode}
                      nameError={this.state.nameError}
                      codeError={this.state.codeError}
                      isButtonDisabled={this.state.buttonDisabled}
                      onActivate={this.onActivate}
                      onSave={this.onSave}
                      onDeactivate={this.onDeactivate}
                    >
                      <SidebarList
                        onSelectLink={this.onSelectLink}
                        listData={this.state.listData}
                        activeId={this.state.activeId}
                        fetchMore={this.fetchMore}
                        hasMore={this._hasMore}
                        module={CONSTANTS.MODULE_TESTPLAN}
                      ></SidebarList>
                    </Sidebar>
                  </div>
                ) : (
                  <SidebarCollapse
                    authKey={CONSTANTS.AUTHKEY_TEST_PLAN}
                    onCollapseSidebar={this.onCollapseSidebar}
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}
                    setName={(val: string) => this.setName(val)}
                    inputName={this.state.inputTestplanName}
                    isShowPopup={this.state.showPopup}
                    module={CONSTANTS.MODULE_TESTPLAN}
                    isShowCodeInput={false}
                    setCode={(val: string) => this.setCode(val)}
                    inputCode={this.state.inputCode}
                    nameError={this.state.nameError}
                    codeError={this.state.codeError}
                    isButtonDisabled={this.state.buttonDisabled}
                    onActivate={this.onActivate}
                    onSave={this.onSave}
                    onDeactivate={this.onDeactivate}
                    showCloneIcon={true}
                  ></SidebarCollapse>
                )}

                <div
                  className={
                    !this.state.collapseSidebar
                      ? "main-layout ml-3 no-padding"
                      : "main-full-layout float-right"
                  }
                >
                  <Landing />
                </div>
              </React.Fragment>
            )}</>)}
          </div>
        )}
      </Translation>
    );
  }
}
